function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#38F997;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M69,98.3l-13.4,0l-13.4,0l-19-19l0-13.4l0-13.4l19-19l13.4,0l13.4,0l19,19l0,13.4l0,13.4L69,98.3z M55.5,90.3l10.1,0 L80,76l0-10.1l0-10.1L65.7,41.4l-10.1,0l-10.1,0L31.1,55.8l0,10.1l0,10.1l14.3,14.3L55.5,90.3z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M88.1,79.1l-13.4,0l-13.4,0l-19-19l0-13.4l0-13.4l19-19l13.4,0l13.4,0l19,19l0,13.4l0,13.4L88.1,79.1z  M74.7,71.1l10.1,0l14.3-14.3l0-10.1l0-10.1L84.8,22.2l-10.1,0l-10.1,0L50.2,36.5l0,10.1l0,10.1l14.3,14.3L74.7,71.1z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6,118.9v19.6c0,1.9,0.4,3.3,1.3,4.4c0.9,1,2.2,1.5,3.9,1.5c1.3,0,2.5-0.3,3.6-0.9c1.1-0.6,2.2-1.4,3.2-2.4v-22.3H35 v30.8h-4.5c-1,0-1.6-0.5-1.9-1.3l-0.5-2.5c-0.6,0.6-1.3,1.2-2,1.8c-0.7,0.5-1.4,1-2.2,1.3c-0.8,0.4-1.6,0.7-2.5,0.9 c-0.9,0.2-1.8,0.3-2.9,0.3c-1.7,0-3.2-0.3-4.5-0.9s-2.4-1.4-3.3-2.4c-0.9-1-1.5-2.3-2-3.7c-0.4-1.4-0.7-3-0.7-4.7v-19.6H15.6z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M42.9,149.7v-30.8h4.5c1,0,1.6,0.5,1.9,1.4l0.5,2.4c0.6-0.6,1.3-1.2,2-1.7c0.7-0.5,1.4-1,2.2-1.3c0.8-0.4,1.6-0.7,2.5-0.9 c0.9-0.2,1.8-0.3,2.9-0.3c1.7,0,3.2,0.3,4.5,0.9c1.3,0.6,2.4,1.4,3.3,2.4s1.5,2.3,2,3.7c0.5,1.4,0.7,3,0.7,4.7v19.6h-7.4v-19.6 c0-1.9-0.4-3.3-1.3-4.4c-0.9-1-2.2-1.5-3.9-1.5c-1.3,0-2.5,0.3-3.6,0.9s-2.2,1.4-3.2,2.4v22.3H42.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M86,110c0,0.6-0.1,1.2-0.4,1.8c-0.3,0.6-0.6,1-1,1.5c-0.4,0.4-0.9,0.8-1.5,1c-0.6,0.2-1.2,0.4-1.9,0.4 c-0.6,0-1.2-0.1-1.8-0.4c-0.6-0.2-1.1-0.6-1.5-1c-0.4-0.4-0.8-0.9-1-1.5c-0.3-0.6-0.4-1.2-0.4-1.8c0-0.7,0.1-1.3,0.4-1.9 c0.2-0.6,0.6-1.1,1-1.5s0.9-0.8,1.5-1c0.6-0.2,1.2-0.4,1.8-0.4c0.7,0,1.3,0.1,1.9,0.4c0.6,0.3,1.1,0.6,1.5,1c0.4,0.4,0.8,0.9,1,1.5 C85.9,108.7,86,109.3,86,110z M84.9,118.9v30.8h-7.4v-30.8H84.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M94.6,149.7v-25.2l-2.7-0.4c-0.6-0.1-1-0.3-1.4-0.6c-0.4-0.3-0.5-0.7-0.5-1.3v-3h4.6v-1c0-1.9,0.3-3.6,0.9-5.2 c0.6-1.6,1.6-3,2.8-4.2c1.3-1.2,2.9-2.1,4.8-2.8c1.9-0.7,4.2-1,6.8-1c0.8,0,1.7,0,2.6,0.1c0.9,0.1,1.6,0.2,2.3,0.4l-0.2,3.8 c0,0.5-0.3,0.7-0.8,0.8c-0.5,0.1-1,0.1-1.7,0.1c-1.9,0-3.6,0.2-4.9,0.5c-1.3,0.3-2.4,0.8-3.2,1.5s-1.4,1.5-1.7,2.5 c-0.4,1-0.5,2.2-0.5,3.5v0.8h19.1v30.5h-7.4v-25.2H102v25.2H94.6z"
});

function SvgUnifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 129.7 164.3",
    style: {
      enableBackground: "new 0 0 129.7 164.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, _ref3), _ref4), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, _ref5, _ref6, _ref7, _ref8));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnifi);
export default __webpack_public_path__ + "static/media/Unifi.24a1724c.svg";
export { ForwardRef as ReactComponent };